import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useLoader } from "../../components/loader/loader";
import {
  cleanFormData,
 
  handleChange,
  handleChange_dolor,
} from "../../services/FormControlService/FormControlServices";
import pluseicon from "./../../assets/img/close-circle.svg";
import CurrencyInput from "react-currency-input-field";
import { ApiUrl } from "../../config/apiConfig";
import { getData, postData } from "../../services/Axios/Axios";
import messageService from "../../services/message/messageService";
import { showAPiError_mesage } from "../../services/validationService/validationservice";
import { PaginationControls } from "../../models/pagination";

interface SelectPlantypes {
  isOpen: boolean;
  SinglePlan?: any;
  closeModal: () => void;
  getDataALLs: () => void;
  formData?: any;
  setFormData?: any;
  getuser_id?: any;
  setuser_id?: any;
}

const SelectPlantype = (props: SelectPlantypes) => {
  const {
    isOpen,
    SinglePlan,
    closeModal,
    getDataALLs,
    getuser_id,
    setuser_id,
  } = props;

  const [error, setError] = useState<any>({});
  const [pagination, setPagination] = useState(new PaginationControls());

  const { show, hide } = useLoader();

  console.log(SinglePlan, "83746rye74");

  useEffect(() => {
    if (SinglePlan && SinglePlan._id) {
      patchDatadeteils(SinglePlan._id);
      setuser_id(SinglePlan._id);
    }
  }, [SinglePlan, SinglePlan?._id]);

  let patchDatadeteils = async (user_id?: any) => {
    console.log(user_id, "user_iduser_iduser_id");
    const skip = (pagination.page - 1) * pagination.limit;
    const obj: any = { skip_number: skip, _id: user_id };
    try {
      const response = await getData(ApiUrl.listPlans, obj);
      console.log(response, "response098765");
      patchdata(response.data[0]);
    } catch (error) {}
  };

  const patchdata = (user: any) => {
    console.log(user, "789876");

    setFormData({
      title: user.title || "",
      sub_title: user.sub_title || "",
      price: user.price || "",
      duration: user.duration || "",
      user_count: user.user_count || "",
      truck_count: user.truck_count || "",
      addon_price: user.addon_price || "",
      is_add_on:true,
      plan_type: user.plan_type || "",
      add_on_truck_count: user.add_on_truck_count || "",
    });
  };


  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "unset !importent",
      padding: "0 !important",
      border: "none !important",
      width: "100%",
      maxHeight: "100vh",
      overflowY: "auto" as "auto",
    },
  };



  const [formData, setFormData] = useState<any>({
    title: "",
    sub_title: "",
    plan_reference_description: "",
    price: "",
    duration: "",
    user_count: "",
    load_count: "",
    asset_count: "",
    driver_count: "",
    truck_count: "",
    trailer_count: "",
    addon_price: "",
    is_add_on: true,
    plan_type: "",
  });

  const themeOptions = [
    { value: "MONTHLY", label: "Monthly" },
    { value: "QUARTERLY", label: "Quarterly" },
    { value: "YEARLY", label: "Yearly" },
  ];

  const themeOptions_TRUE = [
    { value: "true", label: "True" },
    { value: "false", label: "False" },
  ];

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    let isValid = true;
    const errors: { [key: string]: string } = {};
    const regexdot_number = /^[0-9]*$/;

    // Validation checks
    if (!formData.title) {
      errors.title = "Required";
      isValid = false;
    }
    if (!formData.sub_title) {
      errors.sub_title = "Required";
      isValid = false;
    }
    if (!formData.user_count) {
      errors.user_count = "Required";
      isValid = false;
    } else if (!regexdot_number.test(formData.user_count)) {
      errors.user_count = "Only numbers are allowed.";
      isValid = false;
    }
    if (!formData.truck_count) {
      errors.truck_count = "Required";
      isValid = false;
    } else if (!regexdot_number.test(formData.truck_count)) {
      errors.truck_count = "Only numbers are allowed.";
      isValid = false;
    }
    if (!formData.price) {
      errors.price = "Required";
      isValid = false;
    }
    if (!formData.duration) {
      errors.duration = "Required";
      isValid = false;
    }

    if (formData.add_on_truck_count === "" || formData.add_on_truck_count == null) {
      errors.add_on_truck_count = "Required";
      isValid = false;
    } else if (!regexdot_number.test(String(formData.add_on_truck_count))) {
      errors.add_on_truck_count = "Only numbers are allowed.";
      isValid = false;
    }




    if (formData.addon_price === "" || formData.addon_price == null) {
      errors.addon_price = "Required";
      isValid = false;
    } else if (!regexdot_number.test(String(formData.addon_price))) {
      errors.addon_price = "Only numbers are allowed.";
      isValid = false;
    }
    
   

    setError(errors);

    if (isValid) {
      try {
        // Clean and prepare formData
        let cleanedFormData = cleanFormData(formData);

        const updatedFormData = {
          ...cleanedFormData,
          user_count: parseInt(formData.user_count) || 0,
          truck_count: parseInt(formData.truck_count) || 0,
          add_on_truck_count: parseInt(formData.add_on_truck_count) || 0,
        };

        // Add `_id` if `getuser_id` exists
        if (getuser_id) {
          updatedFormData["_id"] = getuser_id;
        }

        // Submit data
        const response = await postData(ApiUrl.addEditPlans, updatedFormData, {
          show,
          hide,
        });

        if (response._id) {
          const messageServices = messageService();
          const successMessage = getuser_id
            ? messageServices.message.updatedSuccess
            : messageServices.message.addedSuccess;
          messageServices.toast("success", successMessage);
          closeModal();
          getDataALLs();
          resert()
    
        } else if (response.error?.msg) {
          showAPiError_mesage(response.error.msg);
        } else if (response.error?.code) {
          showAPiError_mesage(response.error.code);
        }
        if (response?.error?.message) {
          const MessageStore = response?.error?.message;
          showAPiError_mesage(MessageStore);
        }



      } catch (err: any) {
        if (err.response.data.message) {
          const MessageStore =err.response.data.message;
          showAPiError_mesage(MessageStore);
        }
      }
    }
  };


  const resert = () => {


    setFormData({
        sub_title:   "",
        price:  "",
        duration: "",
        user_count:   "",
        truck_count:   "",
        addon_price:   "",
        is_add_on:  true,
        plan_type:  "",
        add_on_truck_count: "",
      });

 
 
};


  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Select Plan Modal"
      ariaHideApp={false}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50"
    >
      <div className="bg-white !w-[30rem] rounded-lg  max-w-2xl shadow-xl">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold">
            {SinglePlan?._id ? "Edit Billing Plan" : "Billing Plan"}
          </h2>
          <button
            type="button"
            className="text-gray-500 hover:text-gray-700"
            onClick={closeModal}
            aria-label="Close"
          >
            <img src={pluseicon} alt="Close" />
          </button>
        </div>

        <form className="space-y-4 p-4">
          {/* Plan Name */}
          <div>
            <input
              type="text"
              placeholder="Plan Name"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500	 hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData?.title}
              name="title"
              onChange={(event: any) => handleChange(event, setFormData, setError)}
            />
            {error?.title && <div className="text-red-500 text-sm">{error?.title}</div>}
          </div>

          {/* Plan Description */}
          <div>
            <input
              type="text"
              placeholder="Plan Description"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500	  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData?.sub_title}
              name="sub_title"
              onChange={(event: any) => handleChange(event, setFormData, setError)}
            />
            {error?.sub_title && <div className="text-red-500 text-sm">{error?.sub_title}</div>}
          </div>

          {/* User Max Limit */}
          <div>
            <input
              type="text"
              placeholder="User max limit"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500	  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData?.user_count}
              name="user_count"
              onChange={(event: any) => handleChange(event, setFormData, setError)}
            />
            {error?.user_count && <div className="text-red-500 text-sm">{error?.user_count}</div>}
          </div>

          {/* Truck Max Limit */}
          <div>
            <input
              type="text"
              placeholder="Truck max limit"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500	  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData?.truck_count}
              name="truck_count"
              onChange={(event: any) => handleChange(event, setFormData, setError)}
            />
            {error?.truck_count && <div className="text-red-500 text-sm">{error?.truck_count}</div>}
          </div>

          {/* Price */}
          <div>
            <CurrencyInput
              type="text"
              placeholder="Enter price"
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500	  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              value={formData?.price}
              name="price"
              prefix="$"
              decimalsLimit={2}
              onValueChange={(value: any, name: any) => handleChange_dolor(value, name, setFormData, setError)}
            />
            {error?.price && <div className="text-red-500 text-sm">{error?.price}</div>}
          </div>

          {/* Plan Type Dropdown */}
          <div>
            <select
              className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500	  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
              name="duration"
              value={formData?.duration}
              onChange={(event: any) => handleChange(event, setFormData, setError)}
            >
              <option value="" disabled>
                Plan Type
              </option>
              {themeOptions.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {error?.duration && <div className="text-red-500 text-sm">{error?.duration}</div>}
          </div>

          {/* Add-On for User (Conditional) */}
          <div>
            {!getuser_id && (
              <div>
                <p className="font-medium">Add-On per user</p>
              </div>
            )}

            {getuser_id && (
              <div>
                <p className="font-medium">Add-On per user</p>
              </div>
            )}

            {(formData?.is_add_on === 'true' || formData?.is_add_on === true ) && (
              <div className="space-y-4 flex gap-3">
                <div className="mt-4 w-full">
                  <CurrencyInput
                    type="text"
                    placeholder="Enter add-on price"
                    className="w-full p-2 text-md border border-gray-300  rounded-md  outline-[1px] transition-all duration-500	  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                    value={formData?.addon_price}
                    name="addon_price"
                    prefix="$"
                    decimalsLimit={2}
                    onValueChange={(value: any, name: any) => handleChange_dolor(value, name, setFormData, setError)}
                  />
                  {error?.addon_price && <div className="text-red-500 text-sm">{error?.addon_price}</div>}
                </div>

                <div className="w-full">
                  <input
                    type="text"
                    placeholder="Add-On Truck max limit"
                    className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500	  hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                    value={formData?.add_on_truck_count}
                    name="add_on_truck_count"
                    onChange={(event: any) => handleChange(event, setFormData, setError)}
                  />
                  {error?.add_on_truck_count && <div className="text-red-500 text-sm">{error?.add_on_truck_count}</div>}
                </div>
              </div>
            )}
          </div>

          {/* Save Button */}
          <div className="flex justify-end items-center p-4 border-t">
            {/* <button
              type="button"
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md  hover:bg-gray-400"
              onClick={closeModal}
            >
              Cancel
            </button> */}
            
            <button
              type="button"
              className="px-6 py-2 bg-customOrange text-white  hover:bg-greenBg  text-sm font-semibold  rounded-md flex items-center justify-center ease-in-out duration-500 shadow-[1px_2px_2px_rgba(0,0,0,0.3)]"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default SelectPlantype;
